import { render, staticRenderFns } from "./DetailDetach.vue?vue&type=template&id=0bf7ac3a&scoped=true"
import script from "./DetailDetach.vue?vue&type=script&lang=js"
export * from "./DetailDetach.vue?vue&type=script&lang=js"
import style0 from "./DetailDetach.vue?vue&type=style&index=0&id=0bf7ac3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7ac3a",
  null
  
)

export default component.exports